export const errors = {
    add: (error: unknown) => {
        // TODO: link to sentry here
        console.error(error)
    }
}
